import hydraDataProvider from "@/@core/providers/hydraDataProvider";
import jwtAuthProvider from "@/@core/providers/jwtProvider";
import mObjectProvider from "@/@core/providers/mediaObjectProvider";
import txtProvider from "@/@core/providers/textProvider";

import FetchHydra from "@/@core/providers/fetch/fetchHydra";
import FetchMediaObject from "@/@core/providers/fetch/fetchMediaObject";
import FetchText from "@/@core/providers/fetch/fetchText";

import { httpDataHeaders, httpAuthHeaders, httpMediaObjectHeaders, httpTextHeaders } from "@/@core/http/headerProvider";

export const httpData = new FetchHydra(process.env.VUE_APP_API_URL, {
  headers: httpDataHeaders,
});

const httpAuth = new FetchHydra(process.env.VUE_APP_API, {
  headers: httpAuthHeaders,
});

/**
 * Used for Media Object requests (GET / POST);
 */
const httpMediaObject = new FetchMediaObject("", {
  headers: httpMediaObjectHeaders,
});

/**
 * Used to fetch as plain text (GET);
 */
const httpText = new FetchText("", {
  headers: httpTextHeaders,
});

export const dataProvider = hydraDataProvider(httpData);
export const authProvider = jwtAuthProvider(httpAuth);
export const mediaObjectProvider = mObjectProvider(httpMediaObject);
export const textProvider = txtProvider(httpText);
